const ONES = [
	"Zero",
	"One",
	"Two",
	"Three",
	"Four",
	"Five",
	"Six",
	"Seven",
	"Eight",
	"Nine",
	"Ten",
	"Eleven",
	"Twelve",
	"Thirteen",
	"Fourteen",
	"Fifteen",
	"Sixteen",
	"Seventeen",
	"Eighteen",
	"Nineteen",
] as const;

const TENS = [
	"",
	"",
	"Twenty",
	"Thirty",
	"Forty",
	"Fifty",
	"Sixty",
	"Seventy",
	"Eighty",
	"Ninety",
] as const;

const SCALES = [
	"",
	" Thousand",
	" Million",
] as const;

/** Whole numbers 0–999_999_999 as title-case English (e.g. 75 → "Seventy-Five"). */
export function numberToEnglishTitleCase (value: number): string {
	if (!Number.isFinite(value) || value < 0) {
		return String(value);
	}
	const n = Math.floor(value);
	if (n === 0) {
		return ONES[0];
	}

	const parts: string[] = [];
	let remaining = n;
	for (let scale = SCALES.length - 1; scale >= 0; scale--) {
		const unit = 1000 ** scale;
		if (remaining < unit) {
			continue;
		}
		const chunk = Math.floor(remaining / unit);
		remaining %= unit;
		parts.push(`${formatUnder1000(chunk)}${SCALES[scale]}`);
	}
	return parts.join(" ");
}

function formatUnder1000 (n: number): string {
	if (n < 20) {
		return ONES[n] ?? String(n);
	}
	if (n < 100) {
		const ten = Math.floor(n / 10);
		const one = n % 10;
		return one ? `${TENS[ten]}-${ONES[one]}` : (TENS[ten] ?? String(n));
	}
	const hundreds = Math.floor(n / 100);
	const rest = n % 100;
	const hundredLabel = hundreds === 1 ? "One Hundred" : `${ONES[hundreds]} Hundred`;
	if (rest === 0) {
		return hundredLabel;
	}
	return `${hundredLabel} ${formatUnder1000(rest)}`;
}

/** e.g. 15 → "Fifteen Percent (15%)" */
export function formatWrittenPercentParenthetical (percent: number): string {
	const n = Math.floor(percent);
	return `${numberToEnglishTitleCase(n)} Percent (${n}%)`;
}

/** e.g. 30 → "Thirty Days (30)" */
export function formatWrittenDaysParenthetical (days: number): string {
	const n = Math.floor(days);
	return `${numberToEnglishTitleCase(n)} Days (${n})`;
}
